import React, { Component } from "react";
import "./Header.scss";
// import titleImage from "../../../assets/images/Bible_icon.png";

class Header extends Component {
  render() {
    const { questionSetDetails } = this.props;
    // <div className="bottom-text">{questionSetDetails.SessionUserName} ({questionSetDetails.SessionUserID})</div>
    return (
      <div className="header-container" id="main_header">
        <div className="header-title-row">
          <div className="title-icon">
            <img src={questionSetDetails.QSSmallLogoURL} alt="bible" />
          </div>
          <div className="title-text">
            <div className="top-text">{questionSetDetails.QSTitle}</div>
            <div className="bottom-text">{questionSetDetails.QSSubtitle}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default Header;
